"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArtemisStatsCodec = exports.ApolloStatsCodec = exports.HealthCodec = exports.Health = void 0;
const t = __importStar(require("io-ts"));
var Health;
(function (Health) {
    Health["GREEN"] = "GREEN";
    Health["YELLOW"] = "YELLOW";
    Health["RED"] = "RED";
})(Health = exports.Health || (exports.Health = {}));
exports.HealthCodec = t.union([t.literal("GREEN"), t.literal("YELLOW"), t.literal("RED")]);
exports.ApolloStatsCodec = t.type({
    id: t.string,
    health: exports.HealthCodec,
    cpuPercent: t.number,
    memoryPercent: t.number,
    rxBytesPerSecond: t.number,
    txBytesPerSecond: t.number,
    gaiaInstances: t.number,
    players: t.number,
    gaia: t.array(t.type({
        id: t.string,
        health: exports.HealthCodec,
        regionId: t.string,
        players: t.number,
    })),
});
exports.ArtemisStatsCodec = t.type({
    id: t.string,
    cpuPercent: t.number,
    memoryPercent: t.number,
    rxBytesPerSecond: t.number,
    txBytesPerSecond: t.number,
    apolloInstances: t.number,
    gaiaInstances: t.number,
    players: t.number,
});
//# sourceMappingURL=types.js.map